module.exports = __webpack_public_path__ + "static-portal/img/4.87e4aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = +TIe
// module chunks = 4